export const GET_MAP_DATA_LOADING='get/map/data/loading';
export const GET_MAP_DATA_SUCCESS='get/map/data/success';
export const GET_MAP_DATA_FAILURE='get/map/data/failure';